<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { email_recipient } from "@/helpers/global.variable";
import draggable from "vuedraggable";

// Custom Components
import PageHeader from "@/components/page-header";
import hotelService from "@/helpers/APIService/hotel.service";
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Email Templates Component

export default {
  page: {
    title: "Email Template",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    ckeditor: CKEditor.component,
    draggable,
    PageHeader,
  },
  computed: {
    ...authComputed,
  },
  data() {
    return {
      editor: ClassicEditor,
      filter: "input",
      title: "Email Template",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Email Template",
          active: true,
        },
      ],
      is_data_loading: true,
      emailRecipientOptions: email_recipient,
      notificationGroupOptions: [],
      notificationGroup: null,
      emailNotificationOptions: [],
      emailTemplate: null,
      emailNotificationSettingOptions: [],
      emailNotificationSetting: null,
      emailTemplateFormData: {},
      temEmailTemplateFormData: {},
    };
  },
  mounted() {
    this.getNotificationGroup();
  },
  methods: {
    getNotificationGroup() {
      UserService.getNotification()
        .then((response) => {
          response.map((item) => {
            this.notificationGroupOptions.push({
              value: item.id,
              text: item.name,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    changeNotification() {
      this.emailNotificationOptions = [];
      this.emailTemplate = null;
      this.emailNotificationSettingOptions = [];
      this.emailNotificationSetting = null;
      if (this.emailTemplate !== null) {
        this.getEmailNotification();
      }
    },
    changeEmailTemplate() {
      this.emailNotificationSettingOptions = [];
      this.emailNotificationSetting = null;
      this.getEmailNotification();
    },
    getEmailNotification() {
      hotelService
        .getEmailNotification(this.notificationGroup, this.emailTemplate)
        .then((response) => {
          response.map((item) => {
            this.emailNotificationSettingOptions.push({
              value: item.id,
              text: item.name,
            });
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    changeEmailNotificationSetting() {
      this.emailTemplateFormData = {};
      hotelService
        .getEmailNotificationSetting(this.emailNotificationSetting)
        .then((response) => {
          response.map((item) => {
            this.emailTemplateFormData = item;
            if (
              this.emailTemplateFormData.mail_detail_section !== null ||
              undefined
            ) {
              this.convertValueToKey();
              this.emailTemplateFormData.email_notification_type.templet_variable.unshift(
                {
                  key: "{{details_table_section}}",
                  value: "{{details_table_section}}",
                }
              );
            }
          });
          this.is_data_loading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    addNewTemplateTableVariable() {
      if (this.emailTemplateFormData !== null) {
        if (this.emailTemplateFormData.mail_detail_section == null) {
          this.emailTemplateFormData.mail_detail_section = {
            title: "",
            detail_infos: [],
          };
        }
        this.emailTemplateFormData.mail_detail_section.detail_infos.push({
          key: "",
          value: "",
        });
      }
    },
    deleteNewTemplateTableVariable(index) {
      if (this.emailTemplateFormData !== null) {
        this.emailTemplateFormData.mail_detail_section.detail_infos.splice(
          index
        );
      }
    },
    onSubmit() {
      this.is_data_loading = true;
      this.convertKeyToValue();
      UserService.updateEmailNotificationSetting(
        this.emailTemplateFormData.id,
        this.emailTemplateFormData
      )
        .then(() => {
          Middleware.notification("Successfully updated !!", "success");

          this.convertValueToKey();
          this.is_data_loading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Convert template variables values into keys
    convertValueToKey() {
      this.emailTemplateFormData.email_notification_type.templet_variable.map(
        (item) => {
          this.emailTemplateFormData.mail_subject =
            this.emailTemplateFormData.mail_subject.replace(
              String(item.value),
              String(item.key)
            );
          this.emailTemplateFormData.mail_content =
            this.emailTemplateFormData.mail_content.replace(
              String(item.value),
              String(item.key)
            );
          if (
            this.emailTemplateFormData.mail_detail_section.detail_infos !==
              undefined ||
            this.emailTemplateFormData.mail_detail_section.detail_infos !==
              null ||
            this.emailTemplateFormData.mail_detail_section.detail_infos !== ""
          ) {
            const arr = JSON.stringify(
              this.emailTemplateFormData.mail_detail_section.detail_infos
            ).replace(String(item.value), String(item.key));
            this.emailTemplateFormData.mail_detail_section.detail_infos =
              JSON.parse(arr);
          }
        }
      );
    },
    // Convert template variable keys in to values
    convertKeyToValue() {
      this.temEmailTemplateFormData = this.emailTemplateFormData;
      this.temEmailTemplateFormData.email_notification_type.templet_variable.map(
        (item) => {
          this.temEmailTemplateFormData.mail_subject =
            this.temEmailTemplateFormData.mail_subject.replace(
              String(item.key),
              String(item.value)
            );
          this.temEmailTemplateFormData.mail_content =
            this.temEmailTemplateFormData.mail_content.replace(
              String(item.key),
              String(item.value)
            );
          if (
            this.emailTemplateFormData.mail_detail_section.detail_infos !==
              undefined ||
            this.emailTemplateFormData.mail_detail_section.detail_infos !==
              null ||
            this.emailTemplateFormData.mail_detail_section.detail_infos !== ""
          ) {
            const arr = JSON.stringify(
              this.temEmailTemplateFormData.mail_detail_section.detail_infos
            ).replace(String(item.key), String(item.value));
            this.temEmailTemplateFormData.mail_detail_section.detail_infos =
              JSON.parse(arr);
          }
        }
      );
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <b-card no-body>
          <b-card-body>
            <!-- Notification Group -->
            <div class="row">
              <div class="col-12">
                <b-form-group
                  class="mb-3 form-label"
                  label="Notification Group"
                  label-for="notification"
                >
                  <b-form-select
                    class="form-select"
                    id="notification"
                    type="text"
                    autocomplete="off"
                    :options="notificationGroupOptions"
                    v-model="notificationGroup"
                    @change="changeNotification"
                  >
                  </b-form-select>
                </b-form-group>
              </div>
            </div>

            <!-- Email Recipient -->
            <div :class="notificationGroup !== null ? 'row' : 'd-none'">
              <div class="col-12">
                <b-form-group
                  class="mb-3 form-label"
                  label="Email Recipient"
                  label-for="recipient"
                >
                  <b-form-select
                    class="form-select"
                    id="recipient"
                    type="text"
                    autocomplete="off"
                    :options="emailRecipientOptions"
                    v-model="emailTemplate"
                    @change="changeEmailTemplate"
                  >
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
            <div v-if="notificationGroup === null">
              <div class="col-12 placeholder-glow">
                <label for="Email Recipient">Email Recipient</label>
                <span class="placeholder w-100 placeholder-lg"></span>
              </div>
            </div>

            <!-- Select email types -->
            <div :class="emailTemplate !== null ? 'row' : 'd-none'">
              <div class="col-12">
                <b-form-group
                  class="mb-3 form-label"
                  label="Select email types"
                  label-for="email_type"
                >
                  <b-form-select
                    class="form-select"
                    id="email_type"
                    type="text"
                    autocomplete="off"
                    :options="emailNotificationSettingOptions"
                    v-model="emailNotificationSetting"
                    @change="changeEmailNotificationSetting"
                  >
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
            <div v-if="notificationGroup !== null && emailTemplate === null">
              <div class="col-12 placeholder-glow">
                <label for="select_email_type">SELECT EMAIL TYPES </label>
                <span class="placeholder w-100 placeholder-lg"></span>
              </div>
            </div>

            <!-- Email template form -->
            <template v-if="!is_data_loading">
              <div
                :class="emailNotificationSetting !== null ? 'row' : 'd-none'"
              >
                <div class="col-md-9" v-if="emailNotificationSetting !== null">
                  <div class="row">
                    <div class="col-md-12 mb-2">
                      <div class="form-group">
                        <label for="Subject">Subject </label>
                        <input
                          type="text"
                          autocomplete="off"
                          class="form-control"
                          id="Subject"
                          name="Subject"
                          v-model="emailTemplateFormData.mail_subject"
                        />
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label for="Content">Content </label>
                      <div class="col-md-12">
                        <div class="form-group">
                          <ckeditor
                            :editor="editor"
                            v-model="emailTemplateFormData.mail_content"
                          >
                          </ckeditor>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2">
                      <div id="charges_rule_div">
                        <b-card>
                          <b-card-header
                            >Edit {Details Section} Content</b-card-header
                          >
                          <b-card-body>
                            <p class="mt-3">
                              <b
                                >Select which fields are displayed within
                                {Details_Section} template variable</b
                              >
                            </p>
                            <template
                              v-if="
                                emailTemplateFormData.mail_detail_section !==
                                  null || undefined
                              "
                            >
                              <div class="col-md-10">
                                <b-form-group
                                  class="mb-3"
                                  label-for="table-title"
                                >
                                  <span slot="label">Table Title </span>
                                  <b-form-input
                                    id="mail_detail_section_title"
                                    type="text"
                                    autocomplete="off"
                                    v-model="
                                      emailTemplateFormData.mail_detail_section
                                        .title
                                    "
                                  ></b-form-input>
                                </b-form-group>
                              </div>
                              <template
                                v-if="
                                  emailTemplateFormData.mail_detail_section !==
                                    null || undefined
                                "
                              >
                                <div
                                  id="charges_row_div"
                                  v-for="(data, index) in emailTemplateFormData
                                    .mail_detail_section.detail_infos"
                                  :key="index"
                                >
                                  <div class="row mt-2">
                                    <div class="col-md-5">
                                      <b-form-group
                                        class="mb-3 form-label"
                                        label-for="Label"
                                      >
                                        <span slot="label">Label </span>
                                        <b-form-input
                                          class="form-input"
                                          :id="data.key"
                                          type="text"
                                          autocomplete="off"
                                          v-model="data.key"
                                        >
                                        </b-form-input>
                                      </b-form-group>
                                    </div>

                                    <div class="col-md-5">
                                      <b-form-group
                                        class="mb-3 form-label"
                                        label-for="Template Variable"
                                      >
                                        <span slot="label"
                                          >Template Variable</span
                                        >
                                        <b-form-input
                                          class="form-input"
                                          :id="data.value"
                                          type="text"
                                          autocomplete="off"
                                          v-model="data.value"
                                        >
                                        </b-form-input>
                                      </b-form-group>
                                    </div>
                                    <div
                                      class="col-md-2 text-dark align-items-center d-flex"
                                    >
                                      <i
                                        class="mdi mdi-trash-can fs-4"
                                        @click="
                                          deleteNewTemplateTableVariable(index)
                                        "
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </template>
                            <p class="mt-3">
                              <a
                                href="javascript: void(0);"
                                id="add_row"
                                @click="addNewTemplateTableVariable()"
                                >+ add another</a
                              >
                            </p>
                          </b-card-body>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-3"
                  v-if="emailNotificationSetting !== null"
                  id="temp"
                >
                  <b-card>
                    <b-card-header> Template Variable </b-card-header>
                    <b-card-body>
                      <draggable
                        v-model="
                          emailTemplateFormData.email_notification_type
                            .templet_variable
                        "
                      >
                        <template
                          v-for="templet_variable in emailTemplateFormData
                            .email_notification_type.templet_variable"
                        >
                          <p
                            :key="templet_variable.key"
                            v-if="
                              templet_variable.key ==
                              '{{details_table_section}}'
                            "
                            href="javascript:void(0)"
                            class="dropdown-item dynamic_var cursor text-primary"
                            v-b-popover.hover.top="
                              'This variable contain a table.'
                            "
                          >
                            {{ templet_variable.key }}
                          </p>
                          <p
                            v-else
                            :key="templet_variable.key + 1"
                            href="javascript:void(0)"
                            class="dropdown-item dynamic_var cursor"
                          >
                            {{ templet_variable.key }}
                          </p>
                        </template>
                      </draggable>
                    </b-card-body>
                  </b-card>
                </div>
              </div>
            </template>

            <!-- Loading area -->
            <template v-if="is_data_loading">
              <div
                :class="emailNotificationSetting !== null ? 'row' : 'd-none'"
              >
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-12 mb-2">
                      <label for="Subject">Subject </label>
                      <div class="form-group placeholder-glow">
                        <span class="placeholder w-100 placeholder-lg"></span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <label for="Content">Content </label>
                      <div class="col-md-12">
                        <div class="form-group placeholder-glow">
                          <span
                            class="placeholder w-100 placeholder-lg"
                            style="height: 300px"
                          ></span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 mt-2">
                      <div id="charges_rule_div">
                        <b-card>
                          <b-card-header class="placeholder-glow">
                            <span
                              class="placeholder w-100 placeholder-lg"
                            ></span>
                          </b-card-header>
                          <b-card-body>
                            <p class="mt-3 placeholder-glow">
                              <b>
                                <span
                                  class="placeholder w-100 placeholder-lg"
                                ></span
                              ></b>
                            </p>
                            <div class="col-md-10 placeholder-glow">
                              <span
                                class="placeholder w-100 placeholder-lg"
                              ></span>
                            </div>
                            <div
                              id="charges_row_div"
                              v-for="number in 4"
                              :key="number"
                            >
                              <div class="row mt-2">
                                <div class="col-md-5 placeholder-lg">
                                  <span
                                    class="placeholder w-100 placeholder-lg"
                                  ></span>
                                </div>
                                <div class="col-md-5 placeholder-lg">
                                  <span
                                    class="placeholder w-100 placeholder-lg"
                                  ></span>
                                </div>
                                <div
                                  class="col-md-2 text-dark align-items-center d-flex placeholder-lg"
                                >
                                  <span
                                    class="placeholder placeholder-lg"
                                    style="width: 30px"
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <p class="mt-3 placeholder-glow">
                              <span
                                class="placeholder placeholder-lg"
                                style="height: 20px; width: 100px"
                              ></span>
                            </p>
                          </b-card-body>
                        </b-card>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <b-card style="max-height: 660px; margin-top: 30px">
                    <b-card-header> Template Variable </b-card-header>
                    <b-card-body
                      style="height: 600px; overflow: scroll; padding-left: 0px"
                    >
                      <template class="placeholder-glow">
                        <p
                          v-for="number in 15"
                          :key="number"
                          href="javascript:void(0)"
                          class="dropdown-item dynamic_var placeholder w-100 placeholder-lg"
                        ></p>
                      </template>
                    </b-card-body>
                  </b-card>
                </div>
              </div>
            </template>

            <!-- Buttons -->
            <div
              :class="emailNotificationSetting !== null ? 'row mt-2' : 'd-none'"
            >
              <div class="col-12 ml-2">
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="onSubmit"
                  :class="{ disabled: is_data_loading }"
                >
                  Update Email Template
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  style="margin-left: 10px"
                  v-b-modal.Preview-mail
                  :class="{ disabled: is_data_loading }"
                >
                  Send Preview Mail
                </button>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>
<style scoped>
.placeholder.w-100.placeholder-lg {
  height: 25px;
}

.placeholder.placeholder-lg {
  height: 25px;
}

#temp .card-body {
  padding: 1.25rem 0rem !important;
  height: 600px;
  overflow-y: scroll;
  padding-left: 0px;
}

#temp .card {
  max-height: 660px;
  margin-top: 30px;
}
</style>
